// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgCircleUser16 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 16 16"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<circle cx={8} cy={8} r={7.5} stroke="#9BDBB6" />
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M10.2917 5.8125C10.2917 7.02083 9.3125 8 8.10417 8C6.89583 8 5.91667 7.02083 5.91667 5.8125C5.91667 4.60417 6.89583 3.625 8.10417 3.625C9.3125 3.625 10.2917 4.60417 10.2917 5.8125ZM9.25 5.8125C9.25 5.17917 8.7375 4.66667 8.10417 4.66667C7.47083 4.66667 6.95833 5.17917 6.95833 5.8125C6.95833 6.44583 7.47083 6.95833 8.10417 6.95833C8.7375 6.95833 9.25 6.44583 9.25 5.8125ZM6.4375 8.625H9.77083C10.9792 8.625 11.9583 9.60417 11.9583 10.8125V11.6458C11.9583 11.9333 11.725 12.1667 11.4375 12.1667H4.77083C4.48333 12.1667 4.25 11.9333 4.25 11.6458V10.8125C4.25 9.60417 5.22917 8.625 6.4375 8.625ZM5.29167 11.125H10.9167V10.8125C10.9167 10.2 10.4375 9.70417 9.8375 9.66667H6.4375C5.80417 9.66667 5.29167 10.1792 5.29167 10.8125V11.125Z"
				/>
			</Svg>
		);
	}
);
SvgCircleUser16.defaultProps = {
	size: 16,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgCircleUser16;
